import React from "react";

import Feedback from "../../../react4xp/shared/forms/feedback";

function Component() {
	return <Feedback />;
}

export default function WrappedComponent() {
	return <Component />;
}
